
import React from "react";
import img1 from "./imgs/C6.jpg";
// import img2 from "./imgs/MCURE.jpg";
import img3 from "./imgs/16.M-Cure 6-c.jpg"
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";


export function MCure6() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img3}/>
                    <img className="product-img" src={img1}/>

                </>
                : <>


                </>
            }
        </>
    )
}